/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-10 15:21:56                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-03-03 14:58:36                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Components
  * WorkorderListItem: Display workorder list item
*/

/* Imports */
/***/

/* Components */
import toast from "react-hot-toast";
import { showApiErrorToast } from "../../../../../../services/api/error";
/***/

import EditCreateDrawer from "../../../../../../components/edit-create-drawer/EditCreateDrawer";
import { api } from "../../../../../../services/api/api";
import ZoneForm from "../../../../../../components/data/zone/ZoneForm";


/**
* WorkorderListItem: Display workorder list item
* @param workorder - Workorder data
* @param onClick - On click event
* @param isLast - Is last item
*/
export default function ZonesAdminActions({
  zone,
  onChange
}: {
  zone: EasyTech.Zone,
  onChange: () => void
}) {
  
  /**
  * updateTechnician: update technician information
  * @param tech - technician data to update
  */
  const updateZone = (zone: EasyTech.Zone): Promise<void> => {
    return new Promise((resolve, reject) => {
      if (zone.type === "B" || (zone.address && zone.radius && zone.type)) {
        api.put("admin/zones/"+zone.id, zone).then((ret) => {
          onChange();
          toast.success("Intervention zones updated");
          return resolve();
        }).catch((error: any) => {
          console.error(error);
          showApiErrorToast(error, { fallbackMessage: "Erreur lors de la mise à jour de la zone" });
          return reject();
        });
      } else {
        toast.error("Form is invalid");
        return reject();
      }
    });
  };
  /***/

  return(
    <div className="admin-wo-actions">
      <EditCreateDrawer data={(zone as EasyTech.Zone)}
        entityName="Intervention zone"
        FormComponent={ZoneForm}
        isNotCreatable={true}
        onSubmit={updateZone} />
    </div>
  );
}
/***/
